<template>
  <modal v-bind="[$props, $attrs]" @modal-close="emitCloseEvent">
    <div class="success-header">
      <img src="/assets/images/success.svg" alt="">
      <h2 class="title">{{ $props.successTitle }}</h2>
    </div>
    <div class="success-body">
      <p class="description"
         v-html="$props.successDescription"></p>
    </div>
  </modal>
</template>

<script>

import Modal from '@/components/common/modal/modal'
export default {
  name: 'success-modal',
  components: { Modal },
  inheritAttrs: false,
  props: {
    successDescription: String,
    successTitle: String,
    size: {
      type: String,
      default: 'lg'
    }
  },
  methods: {
    emitCloseEvent () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.success-header {
  text-align: center;

  img {
    max-width: 80px;
    width: 100%;
    height: auto;
    display: block;
    margin: 0.8rem auto;

    @media (map_get($breakpoints, sm)) {
      max-width: 112px;
    }
  }

  .title {
    font-size: 2.4rem;
    color: $text;
    margin-top: 2.4rem;
    margin-bottom: 1.6rem;
    font-weight: normal;

    @media (map_get($breakpoints, sm)) {
      font-size: 3.2rem;
    }
  }
}

.success-body {
  text-align: center;

  .description {
    margin: 4rem 0;
    font-size: 1.4rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 1.6rem;
    }
  }
}
</style>
